import { createAction } from 'redux-actions';

import reportError from 'ha/helpers/bugsnag/reportError';

import { Actions } from '../constants';

export const init = createAction(Actions.FETCH_FEATURE_FLAGS);
export const success = createAction(Actions.FETCH_FEATURE_FLAGS_SUCCESS);
export const fail = createAction(Actions.FETCH_FEATURE_FLAGS_FAIL);

const fetchFeatureFlags = () => (dispatch, getState, { apiV2 }) => {
  dispatch(init());

  return apiV2
    .getFeatureFlags()
    .then(featureFlags => {
      dispatch(success(featureFlags));
    })
    .catch(error => {
      dispatch(fail());
      reportError(error);
    });
};

export default fetchFeatureFlags;
